import React, { useEffect, useState } from 'react';
import { LeagueCard, type LeagueCardData } from './league-card';

const LeaguesList: React.FC = () => {
  const [items, setItems] = useState<LeagueCardData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/public/leagues')
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        return res.json();
      })
      .then((data: { items: LeagueCardData[] }) => {
        const active = data.items.filter((l) => l.status === 'ACTIVE');
        setItems(active);
        setLoading(false);
      })
      .catch(() => {
        setError('Nie udało się załadować lig.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="events-loading">Ładowanie...</div>;
  }

  if (error) {
    return <div className="events-error">{error}</div>;
  }

  const withNext = items.filter((l) => l.nextRound);
  const withoutNext = items.filter((l) => !l.nextRound);

  return (
    <div className="events-list leagues-list">
      <h1>Ligi</h1>
      {items.length === 0 && (
        <p className="events-empty">
          Nie ma teraz aktywnych lig. Zajrzyj za chwilę albo sprawdź zakończone w sekcji turniejów.
        </p>
      )}
      {withNext.length > 0 && (
        <section className="leagues-section leagues-section--next">
          <h2 className="leagues-section__title">Najbliższe kolejki</h2>
          <ul className="events-cards league-cards">
            {withNext.map((league) => (
              <LeagueCard key={league.id} league={league} />
            ))}
          </ul>
        </section>
      )}
      {withoutNext.length > 0 && (
        <section className="leagues-section leagues-section--rest">
          <h2 className="leagues-section__title leagues-section__title--quiet">
            Pozostałe ligi
          </h2>
          <ul className="events-cards league-cards">
            {withoutNext.map((league) => (
              <LeagueCard key={league.id} league={league} />
            ))}
          </ul>
        </section>
      )}
    </div>
  );
};

export default LeaguesList;
